import {
  REFERRAL_TRIAL_SOURCE,
  type PurchaseAccess,
} from "@petergok/blue-collar-shared";

export const PAID_PROFILE_COMPLETION_ROUTE = "/create-profile";

const FREE_APP_ACCESS_SOURCE = "FREE APP";

const PROFILE_COMPLETION_TRANSITION_ROUTES = new Set([
  PAID_PROFILE_COMPLETION_ROUTE,
  "/payment-success",
  "/redeem-success",
]);

const normalizePathname = (pathname: string) =>
  pathname.length > 1 ? pathname.replace(/\/+$/, "") : pathname;

export const requiresPaidProfileCompletion = (
  purchaseAccess: PurchaseAccess | undefined,
  isProfileComplete: boolean,
): boolean => {
  if (!purchaseAccess || isProfileComplete) {
    return false;
  }

  return [
    purchaseAccess.studyAccess,
    purchaseAccess.allLevelStudyAccess,
    purchaseAccess.aiAccess,
  ].some(
    (access) =>
      access?.active === true &&
      access.source !== REFERRAL_TRIAL_SOURCE &&
      access.source !== FREE_APP_ACCESS_SOURCE,
  );
};

export const shouldRedirectToPaidProfileCompletion = ({
  isSignedIn,
  profileFetched,
  purchaseAccess,
  isProfileComplete,
  pathname,
}: {
  isSignedIn: boolean;
  profileFetched: boolean;
  purchaseAccess: PurchaseAccess | undefined;
  isProfileComplete: boolean;
  pathname: string;
}): boolean =>
  isSignedIn &&
  profileFetched &&
  requiresPaidProfileCompletion(purchaseAccess, isProfileComplete) &&
  !PROFILE_COMPLETION_TRANSITION_ROUTES.has(normalizePathname(pathname));
